/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { compile } from '../path-to-regexp/index.tsx';

export const generatePath = (
	pattern = '/',
	params?: { [paramName: string]: string | number | boolean | null | undefined },
): string => (pattern === '/' ? pattern : compile(pattern)(params));
